export { default } from './FormControlLabel';


//////////////////
// WEBPACK FOOTER
// ../~/@material-ui/core/esm/FormControlLabel/index.js
// module id = 369
// module chunks = 121